import React from "react";

import Image from "../molecules/image";

import logoWhite from "../../../static/design/img/brand/rgb_white_logo_trimmed.svg";

import "../../scss/molecules/_hero.scss";

class Hero extends React.Component {
  render() {
    const heroBody =
      this.props.noBrand || !this.props.title || !this.props.title.length ? (
        ""
      ) : (
        <div className="hero-body">
          <h1 className="hero-seo-title">{this.props.title}</h1>
          <img className="hero-brand-logo" src={logoWhite} alt="Blastic logo" />
          <p className="hero-tagline">{this.props.tagline}</p>
        </div>
      );

    return (
      <section
        className={
          "hero" +
          (this.props.noBrand || !this.props.title || !this.props.title.length
            ? " hero-small"
            : "") +
          (this.props.noGradient ? "" : " hero-gradient")
        }
      >
        <Image
          src={this.props.src}
          fluid={this.props.fluid}
          alt={this.props.alt}
          className="hero-background-img"
          loading="eager"
        />
        {heroBody}
      </section>
    );
  }
}

export default Hero;
